import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-mail-01-Bulk',
  standalone: true,
  templateUrl: '../../assets/mail-01/Bulk.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamMail01BulkIcon {}
